import React from 'react';
import { AuthConsumer } from 'src/app/contexts/authContext';

export const Logout = () => (
    <AuthConsumer>
        {({ logout }) => {
            logout();
            return <span></span>;
        }}
    </AuthConsumer>
);
